module.exports = __webpack_public_path__ + "media/images/games/k2gender/boy-doll-b21386a50479387899ea1a79bd0c4f3c.png";